import React, { useState, useEffect } from "react";
import { Check } from "lucide-react";
import { hero, heroWords, BOOK_URL } from "../../mock";

export default function Hero() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroWords.length), 2600);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="relative overflow-hidden pt-28 lg:pt-36 pb-16 lg:pb-24">
      <div className="absolute inset-0 -z-10" style={{ background: "linear-gradient(115deg,#F3EEE2 0%,#EFE9DD 42%,#E7E2D6 100%)" }} />
      <div className="absolute right-0 top-0 h-full w-1/2 -z-10 hidden lg:block">
        <img src="https://www.lybl.com/images/unsplash/sunlit-nature.webp" alt="" className="h-full w-full object-cover opacity-70 [mask-image:linear-gradient(to_right,transparent,black_45%)]" />
      </div>

      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl reveal">
          <div className="inline-flex items-center gap-3 rounded-full bg-white/80 backdrop-blur px-3 py-1.5 shadow-sm ring-1 ring-black/5">
            <div className="flex -space-x-2">
              {hero.avatars.map((a, i) => (
                <img key={i} src={a} alt="" className="h-6 w-6 rounded-full ring-2 ring-white object-cover" />
              ))}
            </div>
            <span className="text-[13px] font-medium text-lybl-ink/80">{hero.eyebrow}</span>
          </div>

          <h1 className="mt-7 font-serif text-5xl sm:text-6xl lg:text-[68px] leading-[1.02] text-lybl-ink">
            Your{" "}
            <span key={idx} className="inline-block text-lybl-green border-b-2 border-lybl-rust/60" style={{ animation: "wordIn 2.6s ease both" }}>
              {heroWords[idx]}
            </span>
            <br />
            {hero.titleSuffix}
          </h1>

          <p className="mt-6 text-lg text-lybl-muted max-w-md">{hero.subtitle}</p>

          <ul className="mt-7 space-y-3">
            {hero.bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-[15px] text-lybl-ink/90">
                <span className="h-5 w-5 rounded-full bg-lybl-green flex items-center justify-center shrink-0">
                  <Check className="h-3 w-3 text-white" />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <a href={BOOK_URL} target="_blank" rel="noreferrer" data-evt="schedule" className="mt-9 inline-flex items-center gap-2 rounded-full bg-lybl-green px-7 py-4 text-[15px] font-medium text-white hover:bg-lybl-greenDark transition-colors shadow-lg shadow-lybl-green/20">
            {hero.cta} <span aria-hidden>→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
